import { cart } from '../../../../draft-order/assests/translations/en/kn-br-cart.i18n';
import { knbrCart } from '../../../../draft-order/assests/translations/en/kn-br-draft-order.i18n';

export const en = { knbrCart, cart };
